import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c69c4a80&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c69c4a80')) {
      api.createRecord('c69c4a80', component.options)
    } else {
      api.reload('c69c4a80', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=c69c4a80&", function () {
      api.rerender('c69c4a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/items/Index.vue"
export default component.exports